export const GET_ONE_ARTICLE = 'GET_ONE_ARTICLE';
export const TIMELINE = 'TIMELINE';
export const GET_ARTICLES_NEAR_TO = 'GET_ARTICLES_NEAR_TO';
export const CREATE_ARTICLE = 'CREATE_ARTICLE';
export const INITIAL_DATA = 'INITIAL_DATA';
export const DELETE_ARTICLE = 'DELETE_ARTICLE';
export const GET_MY_ARTICLES = 'GET_MY_ARTICLES'
export const GET_MY_BOOKMARKS = 'GET_MY_BOOKMARKS'